import AbstractException from '../AbstractException';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum';

/**
 * Custom exception.
 *
 * @deprecated This exception is not being used by any service and will be
 * removed in the future along with ExceptionTypeEnum.invalidZipCode.
 */
export default class InvalidZipCodeException extends AbstractException {
	public readonly exceptionType = ExceptionTypeEnum.invalidZipCode;
	public readonly name = 'InvalidZipCodeException';
}
